// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ffd2e117","120":"0251484b","453":"9dc53bd3","555":"1adf85b0","649":"56f8b158","806":"867b6da0"}[chunkId] + ".chunk.js";
};